<template>
  <div class="toggle toggle--mobile">
    <label>
      <input type="checkbox" class="list-toggle">
      <div class="flx flx-aic mb_4 toggle__title">
        <h4 class="lh1 font2 c-brand-1 size4 mb">
          Filters
          <span class="icon icon fill-brand-1 icon-size3 icon--angle-down toggle__icon">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512">
              <path d="M119.5 326.9L3.5 209.1c-4.7-4.7-4.7-12.3 0-17l7.1-7.1c4.7-4.7 12.3-4.7 17 0L128 287.3l100.4-102.2c4.7-4.7 12.3-4.7 17 0l7.1 7.1c4.7 4.7 4.7 12.3 0 17L136.5 327c-4.7 4.6-12.3 4.6-17-.1z"></path>
            </svg>
          </span>
        </h4>
      </div>
      <div class="toggle__content">
        <div class="flx-w row row--spacing">

          <div v-for="(filter, index) in availableFilters" :key="`filter-${index}`" class="col mb col--100-s col--100 col--33-l col--50-m col--filters">
            <h4 class="lh1 font2 uppercase mb_4 size2 h-textoverflow">{{ filter.name }}</h4>
            <select class="small" required="" v-model="filters[filter.id]">
              <option v-for="(value, valueIndex) in filter.values" :key="`value-${index}-${valueIndex}`" :value="value">{{ value.name }}</option>
            </select>
          </div>
        </div>
      </div>
    </label>
  </div>
</template>

<script>
export default {
  name: 'Filters',
  props: {
    availableFilters: Array,
    filters: Object
  }
}
</script>
